import { Box, Chip, Typography } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';
import { TENDER_STATES } from 'lib/consts';
import React from 'react';

export interface TenderHeaderProps {
  name?: string;
  externalCode?: string;
  statusCode?: string | number;
}

const TenderHeader: React.FC<TenderHeaderProps> = ({
  name,
  externalCode,
  statusCode,
}) => {
  const statusDef = TENDER_STATES.find(
    (s) => String(s.value) === String(statusCode),
  );
  const chipColor: ChipProps['color'] =
    (statusDef?.color as ChipProps['color']) ?? 'default';

  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        variant="h5"
        sx={{ mb: 0.5, fontWeight: 700, color: 'text.primary' }}
      >
        {name ?? 'Licitación sin nombre'}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: '0.8rem' }}
        >
          Código: {externalCode}
        </Typography>
        <Chip
          label={statusDef?.label ?? 'Otro'}
          color={chipColor}
          size="small"
          sx={{ height: '20px', fontSize: '0.65rem' }}
        />
      </Box>
    </Box>
  );
};

export default TenderHeader;
